export default "__VITE_ASSET__ChVpJnqS__"